<template>
    <router-link :to="person.link" exact class="clean">
        <div class="uk-card uk-card-default uk-box-shadow-hover-large card-person uk-height-full">

            <div class="uk-card-media uk-cover-container">
                <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${person?.image?.mediumSquare})` }" :alt="person.title"></div>
            </div>

            <div class="uk-card-body uk-text-center">

                <div class="card-inner-body">
                    {{ formattedYear ? formattedYear(person.year) : '' }}
                    <h4 class="uk-card-title uk-margin-remove-bottom">{{person.title}}</h4>
                    <label class="text-blue" v-if="person.subtitle">{{person.subtitle}}</label>

                    <p class="summary" v-if="person.summary">{{person.summary}}</p>

                    <blockquote class="uk-margin-small-bottom card-person-quote" v-if="person.secondaryContent">
                        <p><em>{{ person.secondaryContent }}</em></p>
                    </blockquote>
                </div>

                <router-link :to="person.link" :alt="person.title" class="uk-button theme-button button-green uk-margin-small-top">View Profile</router-link>

            </div>

        </div>
    </router-link>
</template>

<script>
export default {
    props: ['person', 'hideLabel', 'formattedYear']
}
</script>
